import { useMemo } from 'react';

import {
  LINKRULE_TYPE,
  getArticleUrl,
  getCompetitionUrl,
  getHeadToHeadUrl,
  getMatchUrl,
  getPlayerUrl,
  getTeamUrl,
  getVideoUrl,
} from '@services/LinkRuleService';
import type { RoundPhase } from '@shared-types/match.types';

export { LINKRULE_TYPE };

export const useArticleLinkRule = (id: string, subPage = '') => getArticleUrl(id, subPage);

export const useCompetitionLinkRule = (id: string, phase?: RoundPhase, subPage = '') =>
  getCompetitionUrl(id, phase, subPage);

export const useMatchLinkRule = (id: string, subPage = '') => getMatchUrl(id, subPage);

export const useVideoLinkRule = (id: string, subPage = '') => getVideoUrl(id, subPage);

export const usePlayerLinkRule = (id: string, competitionId = window.competitionId, phase?: RoundPhase, subPage = '') =>
  getPlayerUrl(id, competitionId, phase, subPage);

export const useTeamLinkRule = (
  id: string,
  competitionId = window.competitionId,
  historical = false,
  phase?: RoundPhase,
  subPage = '',
) => getTeamUrl(id, competitionId, historical, phase, subPage);

export const useHeadToHeadLinkRule = (
  id1: string,
  id2: string,
  competitionId = window.competitionId,
  historical = false,
) => {
  return useMemo(() => getHeadToHeadUrl(id1, id2, competitionId, historical), [competitionId, historical, id1, id2]);
};
